import React, { useId } from 'react';
import { Input } from '../ui/input';

export interface CategoryOption {
  id: string;
  label: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  categories: CategoryOption[];
  className?: string;
  placeholder?: string;
}

/**
 * "Type a few characters, matching categories show up" (2026-08-09) — a
 * plain HTML <datalist> rather than a new Popover/Command-based combobox
 * component: zero new dependency, native browser filter-as-you-type, and
 * this is the only place in the automation editors that needs it so far.
 * The stored value is always the category id (what the engine compares
 * against ticket.category_id at runtime) — the label is shown as the
 * suggestion text, matching how every other condition/case value already
 * works (a plain string in expected_value).
 */
const CategoryAutocompleteInput: React.FC<Props> = ({ value, onChange, categories, className, placeholder }) => {
  const listId = useId();
  return (
    <>
      <Input
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || 'Type to search categories…'}
        className={className}
      />
      <datalist id={listId}>
        {categories.map((c) => (
          <option key={c.id} value={c.id}>{c.label}</option>
        ))}
      </datalist>
    </>
  );
};

export default CategoryAutocompleteInput;
